import React from 'react';
import {oneOf} from 'prop-types';
import compose from 'recompose/compose';
import {injectIntl, intlShape} from 'react-intl';
import CurrencyFormat from 'react-currency-format';
import {isNoU, EmptyFunc} from 'utils/DBUtils';
import AutoSaveField from './abstract/AutoSaveField.jsx';

const currencyPrefixes = {
  USD: '$',
  GBP: '£'
};

const CurrencyFormatWithProxiedOnChange = props => (
  <CurrencyFormat
    onValueChange={props.onChange}
    {...props}
    onChange={EmptyFunc} />
);

class AutoSaveCurrencyInput extends React.Component {
  static propTypes = {
    currency: oneOf(Object.keys(currencyPrefixes)),
    intl: intlShape.isRequired
  };

  static defaultProps = {
    currency: 'USD'
  };

  getValueFromOnChange = ({value, formattedValue, floatValue}) => {
    return Number.isNaN(floatValue) ? 0 : floatValue;
  };

  get hasValidDefaultValue() {
    return !(isNoU(this.props.defaultValue) || Number.isNaN(this.props.defaultValue));
  }

  render() {
    const props = this.hasValidDefaultValue ? this.props : {
      ...this.props,
      value: 0,
      defaultValue: 0
    };

    return (
      <AutoSaveField
        control={CurrencyFormatWithProxiedOnChange}
        getValueFromOnChange={this.getValueFromOnChange}
        placeholder={this.props.field && this.props.field.placeholderKey ? this.props.intl.formatMessage({id: this.props.field.placeholderKey}) : ''}
        {...props}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        prefix={currencyPrefixes[this.props.currency]} />
    );
  }
};

export default injectIntl(AutoSaveCurrencyInput);



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveCurrencyInput.jsx